export enum PaymentStatusEnum {
  initiated = 'Payment initiated',
  pending = 'Payment pending',
  cardUnCaptured = 'Card un-captured',
  partiallyPaid = 'Partially Paid',
  paid = 'Paid',
  cardChargeExpired = 'Card charge expired',
  refunded = 'Refunded',
  partiallyRefunded = 'Partially Refunded',
  adjusted = 'Adjusted',
}

export const PaymentStatus = {
  initiated: {
    value: 'Payment initiated',
    description: 'The payment is initiated.',
  },
  pending: {
    value: 'Payment pending',
    description: 'The payment is still pending.',
  },
  cardUnCaptured: {
    value: 'Card un-captured',
    description: 'The payment is on hold and waiting to be captured.',
  },
  partiallyPaid: {
    value: 'Partially Paid',
    description: 'The payment is partially paid.',
  },
  paid: {
    value: 'Paid',
    description: 'The payment is already paid.',
  },
  cardChargeExpired: {
    value: 'Card charge expired',
    description: 'The uncharged card has been expired.',
  },
  refunded: {
    value: 'Refunded',
    description: 'The payment has been refunded.',
  },
  partiallyRefunded: {
    value: 'Partially Refunded',
    description: 'The payment has partial refunds.',
  },
  adjusted: {
    value: 'Adjusted',
    description: 'The payment has been adjusted.',
  },
}
